module.exports = __webpack_public_path__ + "img/gygx_01.e4891719.jpg";